module.exports = __webpack_public_path__ + "static/articon-316c88688b9907fe232c2090b92bf60e.jpg";